import UpKeepLogo from '../assets/logo-header-light.svg';

export const generateBreadcrumbSchemaMarkup = pathname => {
  if (!pathname) return null;

  const pathSegments = pathname
    .split('/')
    .filter(segment => segment.length > 0);

  const breadcrumbs = [{ name: 'Home', url: 'https://www.upkeep.com/' }];

  let currentPath = 'https://www.upkeep.com';

  pathSegments.forEach((segment, index) => {
    currentPath += `/${segment}`;
    breadcrumbs.push({
      name: segment.replace(/-/g, ' '),
      url: currentPath + '/',
    });
  });

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbs.map((breadcrumb, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: breadcrumb.name,
      item: breadcrumb.url,
    })),
  };
};

export const generateArticleSchemaMarkup = ({
  type = 'Article',
  title,
  image,
  publishDate,
  updatedAt,
  author,
  url,
}) => {
  const schema = {
    '@context': 'https://schema.org',
    '@type': type,
    headline: title,
    mainEntityOfPage: {
      '@id': url,
      '@type': 'WebPage',
    },
    image: image ? [image] : undefined,
    datePublished: publishDate || undefined,
    dateModified: updatedAt || publishDate || undefined,
    author: author
      ? {
          '@type': 'Person',
          name: `${author.firstName} ${author.lastName}`,
          url: `https://www.onupkeep.com/blog/author/${author.firstName.toLowerCase()}-${author.lastName.toLowerCase()}`,
        }
      : undefined,
    publisher: {
      '@type': 'Organization',
      name: 'UpKeep',
      url: 'https://www.upkeep.com',
      logo: {
        '@type': 'ImageObject',
        url: UpKeepLogo,
      },
    },
  };

  Object.keys(schema).forEach(key => {
    if (schema[key] === undefined) delete schema[key];
  });

  return schema;
};

export const generateEventSchemaMarkup = ({
  name,
  description,
  startDate,
  endDate,
  image,
  url,
  organizerName = 'UpKeep',
  organizerUrl = 'https://www.upkeep.com',
  eventStatus,
}) => {
  let eventAttendanceMode = 'https://schema.org/OnlineEventAttendanceMode';

  if (eventStatus === 'on-demand') {
    eventStatus = undefined;
  } else if (eventStatus === 'upcoming' || eventStatus === 'live-event') {
    eventStatus = 'https://schema.org/EventScheduled';
  }

  const formatDateISO = date => {
    if (!date) return undefined;
    const parsedDate = new Date(date);
    return isNaN(parsedDate) ? undefined : parsedDate.toISOString();
  };

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Event',
    name,
    description,
    startDate: formatDateISO(startDate),
    endDate: formatDateISO(endDate),
    eventStatus,
    eventAttendanceMode,
    image: image ? [image] : undefined,
    url,
    organizer: {
      '@type': 'Organization',
      name: organizerName,
      url: organizerUrl,
    },
    performer: {
      '@type': 'Organization',
      name: 'UpKeep',
    },
  };

  Object.keys(schema).forEach(key => {
    if (schema[key] === undefined) delete schema[key];
  });

  return schema;
};
